<template>
  <v-data-table
    :items="statistics"
    :pagination.sync="paginationSync"
    :headers="playerStatisticsHeaders"
    hide-actions
    disable-initial-sort
    item-key="noItem"
  >
    <template slot="items" slot-scope="props">
      <tr style="cursor: pointer" @click="props.expanded = !props.expanded; expandPlayerRow(props.item)">
        <td style="height: 25px; text-align: center">{{ props.item.noShirt }}</td>
        <td style="display: flex; align-items: center; text-align: left; height: 25px">
          <f-flag :code="props.item.player.federationCode" :height="20"></f-flag>
          {{ props.item.player.teamName }}
        </td>
        <td style="height: 25px; text-align: center">{{ props.item.blockPoint }}</td>
        <!-- <td style="height: 25px; text-align: center">{{ props.item.blockKey }}</td> -->
        <td style="height: 25px; text-align: center">{{ props.item.blockFault }}</td>
        <td style="height: 25px; text-align: center">{{ props.item.blockContinue }}</td>
        <td style="height: 25px; text-align: center">{{ props.item.blockTotal }}</td>
      </tr>
    </template>
    <template slot="expand" slot-scope="props">
      <v-container>
        <v-data-table
          :items="matches"
          :headers="matchStatisticsHeaders"
          :loading="matchesLoading"
          :pagination="matchPaginationSync"
          hide-actions
          disable-initial-sort
          item-key="no"
        >
          <template slot="items" slot-scope="props">
            <tr style="cursor: pointer" @click="props.expanded = !props.expanded; expandMatchRow(props.item)">
              <td style="height: 25px">
                <div style="display: flex; align-items: center; text-align: left; height: 25px">
                  <f-flag :code="props.item.beachMatch.teamAFederationCode" :height="20"></f-flag>
                  {{ props.item.beachMatch.teamAName }}
                </div>
              </td>
              <td style="height: 25px">
                <div style="display: flex; align-items: center; text-align: left; height: 25px">
                  <f-flag :code="props.item.beachMatch.teamBFederationCode" :height="20"></f-flag>
                  {{ props.item.beachMatch.teamBName }}
                </div>
              </td>
              <td style="height: 25px; text-align: center">{{ props.item.blockPoint }}</td>
              <td style="height: 25px; text-align: center">{{ props.item.blockFault }}</td>
              <td style="height: 25px; text-align: center">{{ props.item.blockContinue }}</td>
              <td style="height: 25px; text-align: center">{{ props.item.blockTotal }}</td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-container>
              <v-data-table
                :items="sets"
                :headers="setStatisticsHeaders"
                :loading="setsLoading"
                :pagination="setPaginationSync"
                hide-actions
                disable-initial-sort
                item-key="noSet"
              >
                <template slot="items" slot-scope="props">
                  <td style="height: 25px; text-align: center">{{ props.item.noSet }}</td>
                  <td style="height: 25px; text-align: center">{{ props.item.blockPoint }}</td>
                  <td style="height: 25px; text-align: center">{{ props.item.blockFault }}</td>
                  <td style="height: 25px; text-align: center">{{ props.item.blockContinue }}</td>
                  <td style="height: 25px; text-align: center">{{ props.item.blockTotal }}</td>
                </template>
              </v-data-table>
            </v-container>
          </template>
        </v-data-table>
      </v-container>
    </template>
  </v-data-table>
</template>

<script>
import { Request } from '@fivb/sdk'
import Flag from '@/components/Flag'
import { fetchData } from '@/service'

export default {
  props: ['statistics', 'tournamentId'],

  components: {
    'f-flag': Flag,
  },

  data: () => ({
    matches: [],
    matchesLoading: true,
    sets: [],
    setsLoading: true,
    paginationSync: {
      sortBy: 'blockPoint',
      descending: true,
      rowsPerPage: -1,
    },
    matchPaginationSync: {
      sortBy: 'blockPoint',
      descending: true,
      rowsPerPage: -1,
    },
    setPaginationSync: {
      sortBy: 'blockPoint',
      descending: true,
      rowsPerPage: -1,
    },
    playerStatisticsHeaders: [
      { text: '#', value: 'noShirt', align: 'center', sortable: true, },
      { text: 'Name', value: 'teamNamePlayer', align: 'center', sortable: true, },
      { text: 'STUFF BLOCKS', value: 'blockPoint', align: 'center', sortable: true, },
      // { text: 'MONSTER BLOCK', value: 'blockKey', align: 'center', sortable: true, },
      { text: 'FAULTS', value: 'blockFault', align: 'center', sortable: true, },
      { text: 'REBOUNDS', value: 'blockContinue', align: 'center', sortable: true, },
      { text: 'TOTAL ATTEMPTS', value: 'blockTotal ', align: 'center', sortable: true, },
    ],
    matchStatisticsHeaders: [
      { text: 'TeamA', value: 'match.teamACode', sortable: true, },
      { text: 'TeamB', value: 'match.teamBCode', sortable: true, },
      { text: 'STUFF BLOCKS', value: 'blockPoint', align: 'center', sortable: true, },
      { text: 'FAULTS', value: 'blockFault', align: 'center', sortable: true, },
      { text: 'REBOUNDS', value: 'blockContinue', align: 'center', sortable: true, },
      { text: 'TOTAL ATTEMPTS', value: 'blockTotal ', align: 'center', sortable: true, },
    ],
    setStatisticsHeaders: [
      { text: 'Set', value: 'noSet', align: 'center', sortable: true },
      { text: 'STUFF BLOCKS', value: 'blockPoint', align: 'center', sortable: true, },
      { text: 'FAULTS', value: 'blockFault', align: 'center', sortable: true, },
      { text: 'REBOUNDS', value: 'blockContinue', align: 'center', sortable: true, },
      { text: 'TOTAL ATTEMPTS', value: 'blockTotal ', align: 'center', sortable: true, },
    ],
  }),

  methods: {
    async expandPlayerRow (item) {
      this.matches = []
      this.matchesLoading = true

      const query = new Request('GetBeachStatisticList')
        .addAttribute('Fields', 'No NoItem BlockContinue BlockFault BlockPoint BlockTotal DigContinue DigExcellent DigFault DigTotal ReceptionContinue ReceptionExcellent ReceptionFault ReceptionTotal ServeContinue ServeFault ServePoint ServeTotal SetContinue SetExcellent SetFault SetTotal SpikeContinue SpikeFault SpikePoint SpikeTotal AttemptTotal PointTotal TeamFault OpponentError')
        .addAttribute('SumBy', 'Match')
        .addFilter('NoTournaments', this.tournamentId)
        .addFilter('NoPlayer', item.player.no)
        .addFilter('MatchesToUse', 'MatchesStarted')
        .addRelation('BeachMatch', {})
        .addRelation('Player', {})
        .toString()

      const { data } = await fetchData(query)

      this.matches = data
      this.matchesLoading = false
    },

    async expandMatchRow (item) {
      this.sets = []
      this.setsLoading = true

      const query = new Request('GetBeachStatisticList')
        .addAttribute('Fields', 'No NoItem NoSet BlockContinue BlockFault BlockPoint BlockTotal DigContinue DigExcellent DigFault DigTotal ReceptionContinue ReceptionExcellent ReceptionFault ReceptionTotal ServeContinue ServeFault ServePoint ServeTotal SetContinue SetExcellent SetFault SetTotal SpikeContinue SpikeFault SpikePoint SpikeTotal AttemptTotal PointTotal TeamFault OpponentError')
        .addAttribute('SumBy', 'Set')
        .addFilter('NoPlayer', item.player.no)
        .addFilter('NoMatches', item.beachMatch.no)
        .addFilter('MatchesToUse', 'MatchesStarted')
        .addRelation('BeachMatch', {})
        .toString()

      const { data } = await fetchData(query)

      this.sets = data
      this.setsLoading = false
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/TournamentMatchList/StatisticsByPlayer/BestBlocker.vue